module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.name === 'heading') ? _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section-header with-border"
  }, [_vm._v("\n    设置\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "组件间距"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.base.padded),
      callback: function($$v) {
        _vm.$set(_vm.base, "padded", $$v)
      },
      expression: "base.padded"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "加粗"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.config.bold),
      callback: function($$v) {
        _vm.$set(_vm.config, "bold", $$v)
      },
      expression: "config.bold"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "颜色"
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.config.color),
      callback: function($$v) {
        _vm.$set(_vm.config, "color", $$v)
      },
      expression: "config.color"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "布局"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.config.align),
      callback: function($$v) {
        _vm.$set(_vm.config, "align", $$v)
      },
      expression: "config.align"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "left"
    }
  }, [_vm._v("居左")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "center"
    }
  }, [_vm._v("居中")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "right"
    }
  }, [_vm._v("居右")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "字号"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.config.size),
      callback: function($$v) {
        _vm.$set(_vm.config, "size", $$v)
      },
      expression: "config.size"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item + '号',
        "value": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "斜体"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.config.italic),
      callback: function($$v) {
        _vm.$set(_vm.config, "italic", $$v)
      },
      expression: "config.italic"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标题"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.data[0].content),
      callback: function($$v) {
        _vm.$set(_vm.data[0], "content", $$v)
      },
      expression: "data[0].content"
    }
  })], 1)], 1)], 1)]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-34141313", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34141313"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template_editor/heading.vue
// module id = 2606
// module chunks = 0